'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var effects = require('redux-saga/effects');
var networkMiddleware = require('@piconetworks/network-middleware');
var endpoints = require('@piconetworks/endpoints');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);

var types = ['ADD_PAYMENT_METHOD', 'ADD_PAYMENT_METHOD_SUCCESS', 'ADD_PAYMENT_METHOD_ERROR', 'DELETE_PAYMENT_METHOD', 'DELETE_PAYMENT_METHOD_SUCCESS', 'DELETE_PAYMENT_METHOD_ERROR', 'SELECT_PAYMENT_METHOD', 'SET_DEFAULT_PAYMENT_METHOD', 'SET_DEFAULT_PAYMENT_METHOD_SUCCESS', 'SET_DEFAULT_PAYMENT_METHOD_ERROR'];

var creators = function creators(duck) {
  return {
    addPaymentMethod: function addPaymentMethod(payload) {
      return Object.assign({
        type: duck.types.ADD_PAYMENT_METHOD
      }, payload);
    },
    deletePaymentMethod: function deletePaymentMethod(payload) {
      return Object.assign({
        type: duck.types.DELETE_PAYMENT_METHOD
      }, payload);
    },
    selectPaymentMethod: function selectPaymentMethod(payload) {
      return Object.assign({
        type: duck.types.SELECT_PAYMENT_METHOD
      }, payload);
    },
    setDefaultPaymentMethod: function setDefaultPaymentMethod(payload) {
      return Object.assign({
        type: duck.types.SET_DEFAULT_PAYMENT_METHOD
      }, payload);
    }
  };
};

var initialState = {
  isPaymentMethodUpdating: false,
  isPaymentMethodDeleting: false,
  isDefaultBeingSet: false,
  selectedPaymentMethod: null,
  paymentMethods: {},
  paymentMethodErrors: {}
};

var reducer = function reducer(state, action, duck) {
  var type = action.type,
      payload = action.payload,
      error = action.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.ADD_PAYMENT_METHOD:
        draftState.isPaymentMethodUpdating = true;
        draftState.paymentMethods[action.token.id] = null;
        break;

      case duck.types.ADD_PAYMENT_METHOD_SUCCESS:
        draftState.isPaymentMethodUpdating = false;
        draftState.paymentMethods[payload.token_id] = payload.tokenData || true;
        break;

      case duck.types.ADD_PAYMENT_METHOD_ERROR:
        draftState.isPaymentMethodUpdating = false;
        draftState.paymentMethods[payload.token_id] = false;
        draftState.paymentMethodErrors[payload.token_id] = error;
        break;

      case duck.types.DELETE_PAYMENT_METHOD:
        draftState.isPaymentMethodDeleting = true;
        break;

      case duck.types.DELETE_PAYMENT_METHOD_SUCCESS:
        draftState.isPaymentMethodDeleting = false;
        break;

      case duck.types.DELETE_PAYMENT_METHOD_ERROR:
        draftState.isPaymentMethodDeleting = false;
        break;

      case duck.types.SELECT_PAYMENT_METHOD:
        draftState.selectedPaymentMethod = payload.paymentMethod || null;
        break;

      case duck.types.SET_DEFAULT_PAYMENT_METHOD:
        draftState.isDefaultBeingSet = true;
        break;

      case duck.types.SET_DEFAULT_PAYMENT_METHOD_SUCCESS:
        draftState.isDefaultBeingSet = false;
        break;

      case duck.types.SET_DEFAULT_PAYMENT_METHOD_ERROR:
        draftState.isDefaultBeingSet = false;
        break;

    }
  });
};

function* addPaymentMethod(_ref) {
  var types = _ref.types,
      _ref$token = _ref.token,
      token = _ref$token === void 0 ? {} : _ref$token,
      publisherId = _ref.publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    var _token$card, _data$paymentMethods;

    if (!token.id) {
      throw Error('token.id must be provided');
    }

    if (!token.type) {
      throw Error('token.type must be provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.USERS_PAYMENT(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: Object.assign({}, token.account_id && {
          account_id: token.account_id
        }, {
          token: token.id,
          source_type: token.type,
          publisherId: publisherId
        })
      }
    }),
        data = _yield$putResolve.data;

    if (data) {
      yield effects.put(yield effects.call(loaderInvalidationEvent, {
        payload: {
          scope: ['user']
        }
      }));
    }

    var cardId = token === null || token === void 0 ? void 0 : (_token$card = token.card) === null || _token$card === void 0 ? void 0 : _token$card.id;
    var newPaymentMethod = ((data === null || data === void 0 ? void 0 : (_data$paymentMethods = data.paymentMethods) === null || _data$paymentMethods === void 0 ? void 0 : _data$paymentMethods.filter(function (pm) {
      if (!cardId) {
        return false;
      }

      return pm.sourceId === cardId;
    })) || [])[0];
    yield effects.put({
      type: types.ADD_PAYMENT_METHOD_SUCCESS,
      payload: {
        token_id: token.id,
        tokenData: newPaymentMethod
      }
    });
  } catch (error) {
    console.log(error);
    var errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message;
    yield effects.put({
      type: types.ADD_PAYMENT_METHOD_ERROR,
      error: errorMessage || error,
      payload: {
        token_id: token.id
      }
    });
  }
}

function* deletePaymentMethod(_ref) {
  var types = _ref.types,
      sourceId = _ref.sourceId,
      publisherId = _ref.publisherId,
      account = _ref.account,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!account) {
      throw Error('account type must be provided');
    }

    if (!sourceId) {
      throw Error('sourceId must be provided');
    }

    if (!publisherId) {
      throw Error('publisherId must be provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'put',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.USERS_PAYMENT(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          sourceId: sourceId,
          publisherId: publisherId,
          account: account
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned from server');
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.DELETE_PAYMENT_METHOD_SUCCESS,
      payload: {}
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.DELETE_PAYMENT_METHOD_ERROR,
      error: error.message
    });
  }
}

function* setDefaultPaymentMethod(_ref) {
  var types = _ref.types,
      sourceId = _ref.sourceId,
      publisherId = _ref.publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!sourceId) {
      throw Error('sourceId must be provided');
    }

    if (!publisherId) {
      throw Error('publisherId must be provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'put',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.USERS_PAYMENT_DEFAULT(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          sourceId: sourceId,
          publisherId: publisherId,
          retry_charge: false
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned from server');
    }

    if (data.error) {
      throw Error(data.error);
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
      payload: {}
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.SET_DEFAULT_PAYMENT_METHOD_ERROR,
      error: error.message
    });
  }
}

var sagas = function sagas(duck) {
  return {
    addPaymentMethod: function* addPaymentMethod$1(payload) {
      yield addPaymentMethod(Object.assign({}, payload, duck));
    },
    deletePaymentMethod: function* deletePaymentMethod$1(payload) {
      yield deletePaymentMethod(Object.assign({}, payload, duck));
    },
    setDefaultPaymentMethod: function* setDefaultPaymentMethod$1(payload) {
      yield setDefaultPaymentMethod(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.ADD_PAYMENT_METHOD, sagas.addPaymentMethod), effects.takeEvery(types.DELETE_PAYMENT_METHOD, sagas.deletePaymentMethod), effects.takeEvery(types.SET_DEFAULT_PAYMENT_METHOD, sagas.setDefaultPaymentMethod)];
};

var storeDefault = 'payment';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      selectors = _ref.selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
